<template>
  <div class="noContainer">
    <img src="@/assets/icons/icon_no_data.png" />
    <span>没有数据~</span>
  </div>
</template>

<script>
export default {
  name: "NoData",
};
</script>
<style lang="less" scoped>
.noContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 15px;  /* 原30px */

  img {
    width: 60px;  /* 原120px */
  }

  span {
    font-size: 12px;  /* 原24px */
    color: #7c848e;
    margin-top: 5px;  /* 原10px */
  }
}
</style>